import isBefore from 'date-fns/isBefore';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import startOfDay from 'date-fns/startOfDay';
import { Location } from 'history';
import lscache from 'lscache';
import { Account } from 'model/IChat';

import { ActionType, PickLocalState } from './model';

export type ExperienceFilterActions = {
  setInitials(location: Location<unknown>): void;
  setGuestsNumber(params: { nrOfChildren: number; nrOfAdults: number }): void;
  setSelectedDate(value: string): void;
  setSelectedTime(value: string): void;
  setSelectedHost(host: Account): void;
};

const TODAY = new Date();

function isBeforeToday(date: string) {
  return isBefore(
    startOfDay(parse(date, 'yyyy-MM-dd', new Date())),
    startOfDay(TODAY),
  );
}

export function getInitialState(location?: Location) {
  const searchParams = new URLSearchParams(
    location?.search || window.location.search,
  );
  const searchParamsAdults = searchParams.get('adults');
  const searchParamsChildren = searchParams.get('children');
  const nrOfAdults = searchParamsAdults
    ? parseInt(searchParamsAdults, 10)
    : (lscache.get('adults') ?? 4);
  const nrOfChildren = searchParamsChildren
    ? parseInt(searchParamsChildren, 10)
    : (lscache.get('children') ?? 0);

  const dateParam = isValid(new Date(searchParams.get('date')))
    ? searchParams.get('date')
    : null;
  const searchDate = dateParam || lscache.get('date_from');
  const selectedDate =
    searchDate && isBeforeToday(searchDate) ? null : searchDate;

  const selectedTime = searchParams.get('time');

  const params: PickLocalState = {
    nrOfAdults,
    nrOfChildren,
    selectedDate,
    selectedTime,
    selectedHost: null,
  };
  return params;
}

function actionsFactory(
  dispatch: (action: ActionType) => void,
): ExperienceFilterActions {
  return {
    setInitials(location) {
      const params = getInitialState(location);

      dispatch({ type: 'SET_EXPERIENCE_FILTER_INITIALS', payload: params });
    },
    setGuestsNumber(params) {
      dispatch({ type: 'SET_NUMBER_OF_GUESTS', payload: params });
    },
    setSelectedDate(value: string) {
      if (value) {
        dispatch({
          type: 'SET_SELECTED_DATE',
          payload: { selectedDate: value },
        });
      }
    },
    setSelectedTime(value: string) {
      if (value) {
        dispatch({
          type: 'SET_SELECTED_TIME',
          payload: { selectedTime: value },
        });
      }
    },
    setSelectedHost(value) {
      if (value) {
        dispatch({
          type: 'SET_SELECTED_HOST',
          payload: { selectedHost: value },
        });
      }
    },
  };
}

export default actionsFactory;
